import gqlTagGira from 'graphql-tag';

export const QUERY = gqlTagGira`
mutation JwmAssociateField ($input: JiraWorkManagementAssociateFieldInput!) {
  jira {
    jwmAssociateField (input: $input) {
      success
      errors {
        extensions {
          errorType
          statusCode
        }
        message
      }
      associatedIssueTypeIds
    }
  }
}
`;
